import { useEffect, useState } from 'react';

import { COLLECTION_DETAILS_STATUSES_MAP, CollectionDetailsStatus, currentVehicleCollectionStatus$ } from '../VehicleCollectionSubjects';

type UseVehicleCollectionStatusSubResponse = keyof typeof COLLECTION_DETAILS_STATUSES_MAP;

export const useVehicleCollectionStatusSub = (): UseVehicleCollectionStatusSubResponse => {
  const [
    vehicleCollectionStatus, setVehicleCollectionStatus,
  ] = useState<CollectionDetailsStatus>(COLLECTION_DETAILS_STATUSES_MAP.COLLECTION_UNKNOWN);

  useEffect(() => {
    const subscription = currentVehicleCollectionStatus$.subscribe((status) => {
      setVehicleCollectionStatus(status);
    });
    return () => subscription.unsubscribe();
  }, []);
  return vehicleCollectionStatus;
};
